export const GRADE_NAME = "curriculumId";
export const YEAR = "year";
export const SECTION = "section";
export const SECTION_NAME = "name";
export const NO_OF_STUDENT = "noOfStudent";
